import React from "react";
import {
	AutocompleteInput,
	maxLength,
	minLength,
	ReferenceInput,
	required,
	SimpleForm,
	TextInput,
} from "react-admin";
import { bookmakersConfig } from "../bookmakers";
import LandingInput from "./inputs/LandingInput";

const Form = ({ edit = false, ...props }) => (
	<SimpleForm {...props} redirect="list">
		<ReferenceInput
			source="bookmaker_id"
			reference="bookmakers"
			validate={required()}
			disabled={edit}
			{...bookmakersConfig.reference}
		>
			<AutocompleteInput optionText="name" />
		</ReferenceInput>
		<TextInput
			source="name"
			validate={[required(), minLength(5), maxLength(255)]}
			fullWidth
		/>
		<LandingInput
			source="bookmaker_landing_id"
			validate={required()}
			fullWidth
		/>
	</SimpleForm>
);

export default Form;
